import ProfileTabContent
  from '@/modules/common/components/modals/ProfileSettingsModal/components/ProfileTabContent.tsx';
import PasswordTabContent
  from '@/modules/common/components/modals/ProfileSettingsModal/components/PasswordTabContent.tsx';

export enum TabNames {
  Settings = 'settings',
  Password = 'password',
}

export const tabItems  = [
  {
    label: 'Profile settings',
    name: TabNames.Settings,
    container: <ProfileTabContent />,
  },
  {
    label: 'Password',
    name: TabNames.Password,
    container: <PasswordTabContent />,
  },
];
